import DataItem from 'components/DataItem';
import {
  displayTime,
  displayDate,
  getStringValue,
} from 'shared/helpers/common';
import { getAirportDisplay } from 'shared/helpers/quoteBooking';
import useWhiteLabelSettings from 'hooks/useWhiteLabelSettings';
import { DEFAULT_PRIMARY_COLOUR } from 'shared/constants/styleConstants';

export default function PackagesFlightItem({ flightSegment }) {
  const {
    departureAirport,
    arrivalAirport,
    departureTime = '',
    departureDate = '',
    arrivalTime = '',
    arrivalDate = '',
    flightNumber = '',
    checkInTime = '',
    departureTerminal = '',
    arrivalTerminal = '',
  } = flightSegment;

  const departureAirportCode = departureAirport?.code;
  const departureAirportName = departureAirport?.name;
  const arrivalAirportCode = arrivalAirport?.code;
  const arrivalAirportName = arrivalAirport?.name;

  const { whiteLabelSettings: { primaryColour } = {} } =
  useWhiteLabelSettings();

  const backgroundStyle = {
    backgroundColor: primaryColour || DEFAULT_PRIMARY_COLOUR,
  };

  return (
    <div className="pb-8 bg-white">
      <div
        style={backgroundStyle}
        className="mt-[40px] rounded-t-lg text-white text-xl font-bold"
      >
        <div className="p-4 text-[24px] font-medium">
          <div>{
            getAirportDisplay(departureAirportName, departureAirportCode)} - {getAirportDisplay(arrivalAirportName, arrivalAirportCode)}
          </div>
        </div>
      </div>
      <div className="flex flex-wrap pb-3 mx-4">
        <DataItem
          label="Departure Airport"
          value={getStringValue(
            getAirportDisplay(departureAirportName, departureAirportCode),
          )}
        />
        <DataItem label="Departure date" value={displayDate(departureDate, '-', undefined, true)} />
        <DataItem label="Departure time" value={displayTime(departureTime)} />
        <DataItem
          label="Arrival Airport"
          value={getStringValue(
            getAirportDisplay(arrivalAirportName, arrivalAirportCode),
          )}
        />
        <DataItem label="Arrival date" value={displayDate(arrivalDate, '-', undefined, true)} />
        <DataItem label="Arrival time" value={displayTime(arrivalTime)} />
        <DataItem label="Flight number" value={flightNumber} />
        <DataItem label="Check in time" value={displayTime(checkInTime)} />
        <DataItem label="Departure Terminal" value={departureTerminal} />
        <DataItem label="Arrival Terminal" value={arrivalTerminal} />
      </div>
    </div>
  );
}
